import { useState, useEffect } from "react";
import { useAuth } from "@/contexts/AuthContext";
import { useSubscription } from "@/contexts/SubscriptionContext";
import { toast } from "sonner";

export function useMarketplace() {
  const { authAxios } = useAuth();
  const { modules, status, plan, trialDaysLeft, refetch, loading } = useSubscription();
  const [selectedModule, setSelectedModule] = useState(null);
  const [subscribing, setSubscribing] = useState(false);
  const [unsubscribing, setUnsubscribing] = useState(false);
  const [totalMonthly, setTotalMonthly] = useState(0);

  useEffect(() => {
    const total = modules
      .filter(m => m.is_subscribed)
      .reduce((acc, m) => acc + m.price, 0);
    setTotalMonthly(total);
  }, [modules]);

  const handleSubscribe = async (moduleId) => {
    setSubscribing(true);
    try {
      await authAxios.post(`/marketplace/subscribe/${moduleId}`);
      toast.success("Módulo ativado com sucesso!");
      refetch();
      setSelectedModule(null);
    } catch (err) {
      toast.error(err.response?.data?.detail || "Erro ao assinar módulo");
    }
    setSubscribing(false);
  };

  const handleUnsubscribe = async (moduleId) => {
    setUnsubscribing(true);
    try {
      await authAxios.post(`/marketplace/unsubscribe/${moduleId}`);
      toast.success("Assinatura cancelada");
      refetch();
      setSelectedModule(null);
    } catch (err) {
      toast.error(err.response?.data?.detail || "Erro ao cancelar");
    }
    setUnsubscribing(false);
  };

  const handleInterest = (serviceName) => {
    toast.success(`Interesse registrado em "${serviceName}". Entraremos em contato em breve!`);
  };

  return {
    modules,
    status,
    plan,
    trialDaysLeft,
    loading,
    selectedModule,
    setSelectedModule,
    subscribing,
    unsubscribing,
    totalMonthly,
    handleSubscribe,
    handleUnsubscribe,
    handleInterest,
  };
}
